import styled from "@emotion/styled"
import tw from "twin.macro"

export const ImageWrapper = styled.div<ImageWrapperProps>`
  ${tw`relative`}
  ${({ fullWidth }) => (fullWidth ? tw`w-full-vw` : tw`w-full`)}
  ${({ onClick }) => (onClick ? tw`cursor-pointer` : null)}
`

export const ImageRatio = styled.div<ImageRatioProps>`
  padding-bottom: ${({ ratio }) => (Number(ratio.split("/")[1]) / Number(ratio.split("/")[0])) * 100}%;
`

export const StyledImage = styled.img<StyledImageProps>`
  ${({ cover }) => (cover ? tw`absolute inset-0 object-cover object-center h-full w-full` : null)}
  ${({ hover }) =>
    hover ? tw`opacity-0 md:group-hover:opacity-100 pointer-events-none md:group-hover:pointer-events-auto transition-all duration-fast` : null}
`

export const ClickableImageWrapper = styled.div<ClickableImageWrapperProps>`
  ${tw`h-full overflow-hidden`}
  ${({ background }) => (background === "lightest" ? tw`bg-lightest` : tw`bg-transparent`)}
  ${({ enabled }) => (enabled ? tw`cursor-pointer` : null)}
`

type ImageWrapperProps = {
  fullWidth: boolean
  onClick: any
}

type ImageRatioProps = {
  ratio: string
}

type StyledImageProps = {
  cover?: boolean
  hover?: boolean
}

type ClickableImageWrapperProps = {
  background: "lightest" | undefined
  enabled: boolean
}
